import React from 'react';
import './table.scss';

const Table = (data) => {
	return <div className="component table">
		<table>
			<thead>
				<tr>
					{ 
						data.headers.map((header, i) => { 
							return <th key={i}>{ header }</th> 
						})
					}
				</tr>
			</thead>
			
			<tbody>
				{data.rows.map((row, i) => {
					return 	<tr key={i}>{row.map((value, j) => { return <td key={j}> {value} </td> } )}</tr>
				})}
			</tbody>
		</table>
	</div>
}

export default Table;


// WEBPACK FOOTER //
// ./src/components/table/table.jsx